// NPM Imports
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import RevvGridCurrency from "./RG_Currency";
import RevvGridDate from "./RG_Date";
import RevvGridNumber from "./RG_Number";
import RevvGridPercentage from "./RG_Percentage";
import RevvGridSingleSelect from "./RG_SingleSelect";
import RevvGridText from "./RG_Text";

export default function RevvGridCell(props) {
  // Local State Declarations
  const [showDeleteIco, toggleDeleteIco] = useState(false);
  const {
    col,
    currencySymbol,
    index,
    onCellValueChanged,
    pricingPopUp,
    readOnly,
    row,
  } = props;

  function decideCellType() {
    switch (col.type) {
      case "DATE_FIELD":
        return (
          <RevvGridDate
            field={col.field}
            onChange={onCellValueChanged}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-datefield"
          />
        );
      case "NUMBER_FIELD":
        return (
          <RevvGridNumber
            field={col.field}
            onChange={onCellValueChanged}
            pricingPopUp={pricingPopUp}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-numberfield"
          />
        );
      case "PERCENTAGE_FIELD":
        return (
          <RevvGridPercentage
            field={col.field}
            onChange={onCellValueChanged}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-percentagefield"
          />
        );
      case "CURRENCY_FIELD":
        return (
          <RevvGridCurrency
            currencySymbol={currencySymbol}
            field={col.field}
            onChange={onCellValueChanged}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-currencyfield"
          />
        );
      case "SINGLE_SELECT_FIELD":
        return (
          <RevvGridSingleSelect
            field={col.field}
            onChange={onCellValueChanged}
            options={col.props.values}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-singleselectfield"
          />
        );
      case "TEXT_FIELD":
        return (
          <RevvGridText
            field={col.field}
            onChange={onCellValueChanged}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-textfield"
          />
        );
      default:
        return (
          <RevvGridText
            field={col.field}
            onChange={onCellValueChanged}
            readOnly={readOnly}
            row={row}
            data-test="rgcell-default"
          />
        );
    }
  }

  if (col.headerName === "#") {
    return (
      <div
        className="rs-cell-container"
        col-id={col.field}
        col-name={`${col.name}`}
        role="presentation"
        style={{ minWidth: col.minWidth }}
        tabIndex="-1"
        unselectable="on">
        <div
          className="rs-cell"
          onMouseEnter={() => !readOnly && toggleDeleteIco(true)}
          onMouseLeave={() => !readOnly && toggleDeleteIco(false)}>
          {!showDeleteIco && index + 1}
          {showDeleteIco && (
            <div
              className="rs-row-delete-ico"
              onClick={props.deleteRow}
              onKeyPress={() => null}
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "trash-alt"]} />
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div
      className="rs-cell-container"
      col-id={col.field}
      col-name={`${col.name}`}
      role="presentation"
      style={{ minWidth: col.minWidth }}
      tabIndex="-1"
      unselectable="on">
      {decideCellType()}
    </div>
  );
}
